import { arrayOf, func, number } from 'prop-types';
import React from 'react';

import { opportunityShape } from '../../prop-types';
import AgreementRelatedOpportunity from './AgreementRelatedOpportunity';

function AgreementRelatedOpportunities({
  opportunities,
  agreementId,
  onChange,
}) {
  return opportunities.map(opportunity => {
    const relatedAgreementOpportunity = opportunity.agreementOpportunities.find(
      ao => ao.agreement === agreementId,
    );
    return (
      <AgreementRelatedOpportunity
        key={opportunity.id}
        opportunity={opportunity}
        agreementBudget={relatedAgreementOpportunity.budget}
        onChange={onChange}
        agreementId={agreementId}
      />
    );
  });
}

AgreementRelatedOpportunities.propTypes = {
  opportunities: arrayOf(opportunityShape.isRequired).isRequired,
  agreementId: number.isRequired,
  onChange: func.isRequired,
};

export default AgreementRelatedOpportunities;
